import { useEffect, useRef, useState } from "react"
import AdminNavBar from "./AdminNavBar"
import UserNavBar from "./UserNavBar"
import { FetchActiveUsers, User, UserSelect } from "./UserSelect"
import { SelectInstance } from "react-select"

const DeleteUser = () => {
	interface Option {
		value: any;
		label: string;
	}
	
	
	var userRef = useRef<HTMLSelectElement>(null)
	var selectRef = useRef<SelectInstance<Option | null>>(null)

	const [isUserSet, setIsUserSet] = useState(false)
	const [users, setUsers] = useState<User[]>([])
	const [selectedUser, setSelectedUser] = useState<User>({ id: 0, first_name: "", middle_name: "", last_name: "", signed_in: false, photo: "", active: false, email: "", password:"", role:"" })
	const [msg,setMsg] = useState("")

	useEffect(() => {
		FetchActiveUsers(setUsers)
	},[setUsers])

	async function deleteUser() {
		// call DELETE on localhost:4000/user with id in post body
		const payload = {"id": selectedUser.id}
		const response = await fetch(process.env.REACT_APP_API+"/api/userDelete", {
			method: "DELETE",
			body: JSON.stringify(payload)
		})
		const result = await response.json()
		setMsg(selectedUser.first_name + " " + selectedUser.last_name + " deleted.")
		setIsUserSet(false)
		if (userRef && userRef.current) {
			userRef.current.value=""
		}
		if (selectRef && selectRef.current) {
			selectRef.current.setValue({ value: 0, label: "" }, "deselect-option")
		}
		FetchActiveUsers(setUsers)
	}
	
	return (
		<div>
			<AdminNavBar />
			<UserNavBar />
			<h3>Delete User</h3>
			<UserSelect isVisible={isUserSet} setIsVisible={setIsUserSet} setUsers={setUsers} users={users} setSelectedUser={setSelectedUser} ref={userRef} onChange={setMsg} selectRef={selectRef} />
			{isUserSet &&
				<div className="resilire">
					<button onClick={deleteUser}>Delete</button>
				</div>
			}
			{msg && (
				<div>
					{msg}
				</div>
			)}
		</div>


	)
}

export default DeleteUser;
